import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import cx from 'classnames';
import { useAuthContext } from 'components/auth/context';
import { useLearningCenterContext } from 'components/learning-center/context';
import { Anchor } from 'components/ui';
import useTranslation from 'next-translate/useTranslation';
import css from './ReportAConcernBlockNodeView.module.scss';

export const ReportAConcernBlockNodeView = ({
  selected,
  extension,
}: NodeViewProps) => {
  return (
    <NodeViewWrapper>
      <ReportAConcern isSelected={extension.config.isSelectable && selected} />
    </NodeViewWrapper>
  );
};

interface IReportAConcernProps {
  isSelected: boolean;
}

const ReportAConcern = ({ isSelected }: IReportAConcernProps) => {
  const { t } = useTranslation('learning-center/assignments');
  const { session } = useAuthContext();
  const companyUrlAlias = session?.company?.companyUrlAlias;
  const learningCenterContext = useLearningCenterContext();
  const isHotlineEnabled =
    learningCenterContext?.isHotlineEnabled ||
    session?.configurations?.isMisconductReportingEnabled;

  return isHotlineEnabled ? (
    <aside
      className={cx(css.reportAConcernBlock, { [css.selected]: isSelected })}
    >
      <h2 className={css.title}>
        {t('rich-text-block.report-a-concern.title')}
      </h2>
      <p className={css.body}>{t('rich-text-block.report-a-concern.body')}</p>
      <Anchor
        className={css.cta}
        href={`/raise-a-concern/${companyUrlAlias}`}
        size="sm"
        target="_blank"
        variant="button-transparent"
      >
        {t('rich-text-block.report-a-concern.cta')}
      </Anchor>
    </aside>
  ) : null;
};
